"use client";


import { Dispatch, SetStateAction, useEffect, useState, JSX } from "react";

import styles from "@@/styles/components/ui/Hamburger.module.scss";
import mediawind from "@@/public/img/mediawind.svg";
import mediawindWhite from "@@/public/img/mediawind_white.svg";

interface IHamburgerProps {
	toggled: boolean;
	toggle: Dispatch<SetStateAction<boolean>>;
	backgroundIsWhite?: boolean;
	scrollTop?: boolean;
}

export default function Hamburger(props: IHamburgerProps): JSX.Element {
	const { toggled, toggle, } = props;
	const [init, setInit] = useState<boolean>(true);
	const [className, setClassName] = useState<string>(styles.initial_state);


	const classMode = (!props.scrollTop || props.backgroundIsWhite) ? styles.dark : styles.white;

	useEffect(() => {
		if (init) {
			setInit(false);
			return;
		}

		if (toggled) {
			setClassName(styles.transition_in);

			setTimeout(() => {
				setClassName(styles.final_state);
			}, 190);

		} else {
			setClassName(styles.transition_out);

			setTimeout(() => {
				setClassName(styles.initial_state);
			}, 190);
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [toggled]);

	function toggleAnimation() {
		toggle(latest => !latest);

		if (className === styles.initial_state) {
			setClassName(styles.transition_in);

			setTimeout(() => {
				setClassName(styles.final_state);
			}, 190);
		} else {
			setClassName(styles.transition_out);

			setTimeout(() => {
				setClassName(styles.initial_state);
			}, 190);
		}
	}

	return (
		<div className={`${styles.container} ${classMode}`}>
			<div
				className={className}
				onClick={toggleAnimation}
			>
				<div className={styles.top}></div>
				<div className={styles.mid}></div>
				<div className={styles.bot}></div>
			</div>
		</div>
	);
}
